import React from "react";
import { ConfirmationReservationService } from "../pages/Reservation/services/ConfirmationReservationService";

const reservationService = new ConfirmationReservationService();

export function DohoneProvider(props: { children: React.ReactNode }) {
    const [dohoneInfo, setDohoneInfo] = React.useState<DohoneInfo | null>(null);
    const [isLoading, setIsLoading] = React.useState(false);

    const refresh = React.useCallback(async () => {
        if (!dohoneInfo && !isLoading) {
            setIsLoading(true);
            try {
                const info = await reservationService.getDohoneInfo();
                setDohoneInfo(info);
            } catch (error) {
                console.error("Dohone info fetch failed:", error);
                throw error;
            } finally {
                setIsLoading(false);
            }
        }
    }, [dohoneInfo, isLoading]);

    const value = React.useMemo(
        () => ({ info: dohoneInfo, refresh }),
        [dohoneInfo, refresh]
    );

    return (
        <DohoneContext.Provider value={value}>
            {props.children}
        </DohoneContext.Provider>
    );
}

type DohoneInfo = {
    commercialName: string;
    codeMarchand: string;
};

export type DohoneContextType = {
    info: DohoneInfo | null;
    refresh: () => Promise<void>; 
};

const DohoneContext = React.createContext<DohoneContextType>({
    info: null,
    refresh: () => Promise.resolve()
});

export function useDohone() {
    return React.useContext(DohoneContext);
}
